import setReduxAction from 'modules/redux/actions/set'
import { joinUpperCaseUnderscoreStringUtil } from 'packages/src'
import {
  TRAINING_APP_ACTION,
  TRAINING_APP_PATH
} from 'modules/training/modules/app/constants/index.js'

export function updateFromPlatformAppAction (value) {
  return dispatch => {
    dispatch(
      setReduxAction({
        type: joinUpperCaseUnderscoreStringUtil(
          TRAINING_APP_ACTION.UPDATE_FROM_PLATFORM,
          value
        ),
        payload: {
          value,
          path: TRAINING_APP_PATH.FROM_PLATFORM
        }
      })
    )
  }
}
